import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function ProjetRSE({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>Monsieur,</p>
      <p>
        Je vous transmets le projet de {variablesData.genre_masc_complet}{" "}
        {variablesData.cadre_technico_commercial_nom} (
        {variablesData.cadre_technico_commercial_fonction} ) qui se propose de
        mettre en place un atelier expérimental de l'amélioration de la relation
        client (ARC) au sein de notre entreprise. Pour sa mise en œuvre des
        méthodes collaboratives seraient utiles.
      </p>
      <p>
        {variablesData.genre_masc_complet}{" "}
        {variablesData.cadre_technico_commercial_nom}, 26 ans est un jeune cadre
        (1 an d'ancienneté dans le poste). Plein d'ambition et ayant le goût
        d'entreprendre, il comble son manque d'expérience par sa faculté
        d'adaptation aux situations nouvelles. Il est fortement motivé par ce
        projet RSE dans lequel il s'est déjà beaucoup investi et aurait besoin
        de suivre une formation ciblée.
      </p>
      <p>
        Cette proposition est le fruit de nombreuses heures de recherche
        effectuées par {variablesData.genre_masc_complet}{" "}
        {variablesData.cadre_technico_commercial_nom} en plus de sa charge de
        travail.
      </p>
      <MailSignature
        emetteurLogo={ProjetRSE.metadata.emetteurLogo}
        emetteur={ProjetRSE.metadata.emetteur}
        emetteurPoste={ProjetRSE.metadata.emetteurPoste}
        emetteurEntreprise={ProjetRSE.metadata.emetteurEntreprise}
      />
    </div>
  );
}

ProjetRSE.metadata = {
  titre: "Projet RSE – questionnaire RSE de vos clients",
  cleMail: "projet_rse",
  messageTransfert: false,
  emetteur: "Leïla SEBAG",
  emetteurPoste: "Responsable du service Commercial",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -10,
  piecesJointes: ["formation-rse-monsieur-bart"],
} as MailMetadata;

export default ProjetRSE;
